export const GET_SUCURSAL = '[Sucursal] Get Sucursal';
